var card_default = {
  "link": "cRjZW",
  "container": "LYUbc",
  "cardLayout": "s6Euq",
  "imageEnd": "iLIWk",
  "imageStart": "Nkehe",
  "imageTop": "mhbiR",
  "right": "QEuXH",
  "ltr": "q85E1",
  "rtl": "Z-U5-",
  "imageContainer": "uY06w",
  "image": "XP79f",
  "responsiveImage": "r1Y9j",
  "squareImage": "yKBat",
  "rectangleImage": "CZt--",
  "squareRatio": "WtzQZ",
  "rectangleRatio": "TqV9L",
  "imageFill": "o4rO4",
  "imageFit": "DQ-OA",
  "imageRibbon": "G7tWA"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
